require('./brokerContributionInvestmentFundStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const { FormattedText, formatText } = require('core/i18n').i18n;
const Immutable = require('immutable');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const { OKConsents } = require('gdpr-consents/components/OKConsents/OKConsents.js');
const ExtantCostDetails = require('components/broker/brokerContributionInvestment/brokerContributionInvestmentFundStep2/components/extantCostDetails');
const { GDPRSignaturePattern } = require('components/gdprSignaturePattern/gdprSignaturePattern');
const BrokerContributionInvestmentFundDetails = require('../brokerContributionInvestmentFundDetails/brokerContributionInvestmentFundDetails');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { BrokerFundLegalDocumentDisclaimer } = require('../../brokerFundLegalDocumentDisclaimer/brokerFundLegalDocumentDisclaimer');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';

// @ constants
const {
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    FIRST_STEP,
    SECOND_STEP,
    BROKER_GREEN_FUND,
    BROKER_YELLOW_FUND,
    BROKER_MIFID_FUND_GREEN,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_MIFID_VERSION_1,
    BROKER_PRODUCT_TYPE_FUNDS,
    API_CHANNEL
} = require('constants/index');

const {
    messages: {BROKER_HIRE_INVESTMENT_FUND_AND_GDPR}
} = require('constants/operationTypes');

const { HIRE_INITIAL_FUNDS_GDPR_PID } = require('constants/gdprPlacementIds');

// @ helpers
const { getFormattedString } = require('utilities/currencyHelper');
const { taggingEventHandled } = require('utilities/taggingEventHandled')
const { PROC_BROKER_INVESTMENT_CONTRIBUTIONS  } = require('utilities/tagging.js')
const { getCCOfficeChannel } = require('utilities/contactCenter/printerHelper');
const { getPersonTypeAndCode } = require('utilities/hash');
const { recordPage } = require('utilities/tagging.js')


class BrokerContributionInvestmentFundStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.buildDisclaimerCheckbox = this.buildDisclaimerCheckbox.bind(this);
        this.handleReadCheckChange = this.handleReadCheckChange.bind(this);
        this.buildMifidDisclaimer = this.buildMifidDisclaimer.bind(this);

        this.state = {
            allowClickDisclaimer: false,
            showDisclaimerErrorState: false
        }
    }

    componentDidMount() {
        const {
            history,
            immContributionFunds,
            immFlagBasedFeatures,
            immAccounts,
            extantDataFetch,
            validateEconomicReport,
        } = this.props;

        const isin = immContributionFunds.getIn(['contributionFunds', 'isin'])
        const amount = immContributionFunds.getIn(['steps', FIRST_STEP, 'amount']);
        const accountNumber = immContributionFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currency = immAccount.getIn(['balance', 'currency']);
        const featureFlagShowExantCostBuyFunds = immFlagBasedFeatures.get("wealth_funds_buy_show_costs");

        if (
            immContributionFunds.get('fetchingDataExt') === false &&
            !immContributionFunds.get("fetchDataExtError") &&
            currency !== null &&
            featureFlagShowExantCostBuyFunds
            ) {
                const query = {
                    importe: {
                        amount: amount,
                        currency: currency
                    },
                    isin: isin
                };
                extantDataFetch(query, history);
            }
        validateEconomicReport(history);
        const customData = {
            event_name: "step_terms_conditions",
            pageName: "/buyFundsPeriodicContribution/step2/termsConditions",
            sectionFamily: "wealth",
            sectionCategory: "products",
            sectionName: "funds",
            serviceType: "productContracting",
            interactionType: "funnel",
            processType: "buyFundsPeriodicContribution",
            processStep: "step2",
            processDetail: "termsConditions",
            productName: isin,
            periodicity: immContributionFunds.getIn(['steps', FIRST_STEP, 'periodicityValue']),
            amount: amount,
        }

        recordPage(customData);

        taggingEventHandled(PROC_BROKER_INVESTMENT_CONTRIBUTIONS, 'contributionFundStep2', isin)
        this.props.onStepChange('step 2')
    }

    componentWillUnmount() {
        this.props.resetFetchedPre();
        this.props.removeLegalDocumentation();
        this.props.handleChangeReadChecked(false);
    }

    buildColumns() {
            return [
                'brokerContributionFundStep2-destinationSubs',
                'account',
                'brokerContributionFundStep2-amountSubs',
                'brokerContributionFundStep2-lastValue'
            ];
    }

    buildDetailsColumns() {
        const { immContributionFunds, immAccounts, immFlagBasedFeatures, immBrokerMyInvestments  } = this.props;

        const fundName = immContributionFunds.getIn(['steps', 0, 'contributionFunds', 'name']);
        const accountNumber = immContributionFunds.getIn(['steps', 0, 'accountNumber']);
        const immAccount = immAccounts.get(accountNumber);
        const currencyObject = Immutable.Map().merge({
            amount: immContributionFunds.getIn(['steps', 0, 'amount']),
            currency: immAccount.getIn(['balance', 'currency'])
        });
        const amountInvestment = getFormattedString(currencyObject);
        const liquidAmount = immContributionFunds.getIn(['contributionFunds', 'netAssetValue']);
        const liquidAmountText = getFormattedString(liquidAmount);
        const columnsContent = [fundName, 'account', amountInvestment, liquidAmountText];
        const columns = this.buildColumns();

        const featureFlagShowExtantCostBuyFunds = immFlagBasedFeatures.get('wealth_funds_buy_show_costs');

        if (featureFlagShowExtantCostBuyFunds) {
            return (
                <ExtantCostDetails
                    immContributionFunds={immContributionFunds}
                    immAccount={immAccount}
                    immFlagBasedFeatures={immFlagBasedFeatures}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                />
            )
        }
    }

    buildDisclaimerCheckbox() {
        const { immContributionFunds } = this.props;
        const { showDisclaimerErrorState } = this.state



        const fundName = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'name']);
        const fundIsin = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
        const fundSecId = immContributionFunds.getIn([
            'steps',
            FIRST_STEP,
            'contributionFunds',
            'secId'
        ]);
        const isSpanish = (fundIsin + '').slice(0, 2).toLowerCase() === 'es';
        const checked = immContributionFunds.getIn(['steps', SECOND_STEP, 'readChecked']);

        return (
            <div className="contribution-fund-step2__declaration-text">
                <BrokerFundLegalDocumentDisclaimer
                    disclaimerErrorState={showDisclaimerErrorState}
                    disclaimerErrorMessage={formatText('brokerContributionFundStep2-checkError')}
                    disclaimerChecked={checked}
                    onDisclaimerCheckChange={this.handleReadCheckChange}
                    isSpanish={isSpanish}
                    fundName={fundName}
                    fundIsin={fundIsin}
                    fundSecId={fundSecId}
                    enableTransactionCost={true}
                />
            </div>
        );
    }

    buildInfoSubs() {
            return (
                <OKMessage
                    type="informative"
                    title={formatText('brokerContributionFundStep2-infoTitle')}
                >
                    <FormattedText value="brokerContributionFundStep2-info" />
                </OKMessage>
            );
    }

    buildMifidDisclaimer() {
        const { immBrokerConvenienceMiFIDTest, immBrokerMiFIDProducts, immContributionFunds } = this.props;
        const usingMifidv1 = immBrokerConvenienceMiFIDTest.get('mifidVersion') === BROKER_MIFID_VERSION_1;

        if (usingMifidv1) {
            const fundType = immContributionFunds.getIn([
                'steps',
                FIRST_STEP,
                'contributionFunds',
                'customCategoryId3'
            ]);

            if (fundType === BROKER_YELLOW_FUND || fundType === BROKER_GREEN_FUND) {
                const fundMifidId =
                    fundType === BROKER_YELLOW_FUND
                        ? BROKER_MIFID_FUND_YELLOW
                        : BROKER_MIFID_FUND_GREEN;

                if (immBrokerMiFIDProducts.getIn(['products', fundMifidId, 'loading'])) {
                    return <LoadingSection />;
                } else {

                    const mifidDisclaimer = immBrokerMiFIDProducts.getIn([
                        'products',
                        fundMifidId,
                        'disclaimer'
                    ]);

                    if(mifidDisclaimer) {
                        return (
                            <div className="contribution-fund-step2__mifid-disclaimer">
                                <OKMessage type="informative">
                                    {mifidDisclaimer}
                                </OKMessage>
                            </div>
                        );
                    }

                }
            }
        }
    }

    handleReadCheckChange(ev) {
        const { handleChangeReadChecked } = this.props
        const { allowClickDisclaimer } = this.state
        if(allowClickDisclaimer) {
            this.setState({ showDisclaimerErrorState: false })
            handleChangeReadChecked(ev.target.checked)
        }else {
            this.setState({ showDisclaimerErrorState: true })
        }
    }

    renderDocumentationBox = () => {
        const { immContributionFunds } = this.props;
        if (immContributionFunds.get('fetchingDocumentsValidate')) {
            return null;
        }

        const fundName = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'name']);
        const fundIsin = immContributionFunds.getIn(['steps', FIRST_STEP, 'contributionFunds', 'isin']);
        const fundSecId = immContributionFunds.getIn([
            'steps',
            FIRST_STEP,
            'contributionFunds',
            'secId'
        ]);
        const enableEconomicReport = immContributionFunds.get('enableEconomicReport');

        const tealium = {
            categoriaEvento:"buyFundsPeriodicContribution",
            accionEvento:"funds documentation",
            productName: fundName,
            productID: fundIsin
            };

        return (
            <BrokerLegalDocumentation
                className="contribution-fund-step2__documentation-box"
                isin={fundIsin}
                secId={fundSecId}
                productDefinition={fundName}
                productType={BROKER_PRODUCT_TYPE_FUNDS}
                reportCompleted={() => this.setState({ allowClickDisclaimer: true })}
                enableTransactionCost={false}
                enableEconomicReport={enableEconomicReport}
                tealium={tealium}
            />
        );
    }

    render() {
        const { immContributionFunds  } = this.props;
        const { showDisclaimerErrorState } = this.state
        const showGDPRSignaturePattern = __CONTACT_CENTER__ ? true : immContributionFunds.getIn(['steps', SECOND_STEP, 'readChecked']);
        const columnsContainer = this.buildDetailsColumns();
        const mifidDisclaimer = this.buildMifidDisclaimer();
        const infoLabel = this.buildInfoSubs();
        const hasPreviousContributions = immContributionFunds.getIn(['steps', 0, 'hasPreviousContributions']);
        const trxId =  hasPreviousContributions ? 201 : 202;
        const contractNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'contractNumber']);
        const productNumber = immContributionFunds.getIn(['steps', 0, 'originFundPurchased', 'product']);
        let operative;
        const consentElement = (<OKConsents placementId={HIRE_INITIAL_FUNDS_GDPR_PID} />);

        const operationParams = {
            ammount: `+${immContributionFunds.getIn(['steps', 0, 'amount'])}`,
            channel: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
            clientId: getPersonTypeAndCode(immContributionFunds.getIn(['steps', 0, 'clientId'])).f.toString(),
            clientType: getPersonTypeAndCode(immContributionFunds.getIn(['steps', 0, 'clientId'])).type,
            currency: immContributionFunds.getIn(['steps', 0, 'customMinimumPurchaseAmount', 'currency']),
            originAccount: `${API_ENTERPRISE_NUMBER}${API_CENTER}${productNumber}${contractNumber}`,
        };

        if (immContributionFunds.get('isFetchingPre')) {
            return <LoadingSection />
        } else if (immContributionFunds.get('fetchingDataExt')) {
            return <LoadingSection />
        } else {
            return (
                <div className="contribution-fund-step2">
                    <header className="contribution-fund-step2__header">
                        <h2 className="contribution-fund-step2__title">
                            <FormattedText
                                value="brokerContributionFundStep2-title"
                                className="contribution-fund-step2_description"
                            />
                        </h2>
                    </header>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>

                    <FormattedText
                        value="brokerContributionFundStep2-description"
                        className="contribution-fund-step2__description"
                    />

                    {columnsContainer}
                    {consentElement}
                    {mifidDisclaimer}
                    <WebappRender>
                        <div className="row">
                            <div className="col-sm-12">
                                {this.renderDocumentationBox()}
                            </div>
                        </div>
                    </WebappRender>
                    {infoLabel}
                    <WebappRender>
                        <div className="contribution-fund-step2__checkbox">
                            <div className="contribution-fund-step2__checkbox__message">
                                {showDisclaimerErrorState &&
                                    <OKMessage type="warning">
                                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                                    </OKMessage>
                                }
                            </div>
                            {this.buildDisclaimerCheckbox()}
                        </div>
                    </WebappRender>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    {showGDPRSignaturePattern &&
                        <div className="contribution-fund-step2__signature-container">
                            <GDPRSignaturePattern
                                operationType={trxId}
                                operationParams={operationParams}
                                multiOTPMessageCode={BROKER_HIRE_INVESTMENT_FUND_AND_GDPR}
                                isWealth={true}
                            />
                        </div>
                    }
                </div>
            );
        }
    }
}

BrokerContributionInvestmentFundStep2.defaultProps = {
    owner: ''
};

BrokerContributionInvestmentFundStep2.propTypes = {
    history: PropTypes.object.isRequired,
    onStepChange: PropTypes.func,
    immContributionFunds: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    handleChangeReadChecked: PropTypes.func.isRequired,
    resetFetchedPre: PropTypes.func.isRequired,
    validateEconomicReport: PropTypes.func.isRequired,
    removeLegalDocumentation: PropTypes.func.isRequired,
    extantDataFetch: PropTypes.func,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
};

module.exports.constructor = BrokerContributionInvestmentFundStep2;
module.exports.BrokerContributionInvestmentFundStep2 = connect(
    state => ({
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts,
        immBrokerMyInvestments: state.brokerMyInvestments
    })
)(withRouter(BrokerContributionInvestmentFundStep2));
